export function checkForFormFieldErrors(field, hasFormBeenSubmitted) {
  return field.invalid && hasFormBeenSubmitted;
}
